module.exports = __webpack_public_path__ + "fonts/AlteDIN1451Mittelschrift.dbcee9c2.woff2";